var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionResult',{attrs:{"status":404,"from":'notFound'}})}
var staticRenderFns = []

export { render, staticRenderFns }